// Данные пользователя в sessionStorage — их читают экраны MES (роль, права, цех).
// Один набор на всех: вход через /login и переход из /ai (там вход свой, см.
// ai/aiApi.js) заполняют сессию одним и тем же кодом, иначе поля разойдутся.
export function saveSessionUser(user) {
  sessionStorage.setItem('role', user.role);
  // Главный менеджер — единственный, кто выписывает распоряжения на
  // отгрузку. Экран спрашивает об этом на каждом открытии, поэтому
  // держим ответ рядом с ролью.
  sessionStorage.setItem('can_ship', user.can_ship ? '1' : '0');
  // Заявку на производство выписывает плановый отдел, а не
  // должность: право личное, и экраны спрашивают его так же.
  sessionStorage.setItem('can_plan', user.can_plan ? '1' : '0');
  // Поставщик программы. Его раздел клиенту не показывается вовсе:
  // о том, что новый цех можно открыть, завод знать не должен.
  sessionStorage.setItem('is_platform', user.is_platform ? '1' : '0');
  // Настройки ИИ (ключ) — только владелец платформы с правами суперпользователя
  sessionStorage.setItem('is_superuser', user.is_superuser ? '1' : '0');
  // Модуль «Автопланировщик» подключает владелец платформы клиенту
  sessionStorage.setItem('autoplanner', user.autoplanner ? '1' : '0');
  // Пока нет обмена с 1С по номенклатуре — менеджер заводит товар сам
  sessionStorage.setItem('can_add_nom', user.can_add_nomenclature ? '1' : '0');
  // Вести смену из браузера — по личному разрешению: считать выпуск
  // должен моноблок у пресса, иначе он остаётся без номера смены и
  // перестаёт отправлять листы.
  sessionStorage.setItem('can_web_terminal', user.can_web_terminal ? '1' : '0');
  // Главный администратор — для экранов, где галочку выдаёт только он.
  sessionStorage.setItem('is_super_admin',
    (user.is_platform || (user.role === 'admin' && user.all_branches)) ? '1' : '0');
  sessionStorage.setItem('can_edit_1c_settings', user.can_edit_1c_settings ? '1' : '0');
  sessionStorage.setItem('user_name', `${user.first_name} ${user.last_name}`.trim() || user.username);
  // Свой цех — в шапке. Пока цех был один, там стоял «Шымкент» прямо в
  // коде; человек из Алматы видел чужой город и не понимал, в свою ли
  // систему вошёл.
  sessionStorage.setItem('branch_name', user.branch_name || '');
}
